// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/substance/dist/substance-pagestyle.css
// module id = 3
// module chunks = 0